const UNSPLASH_ACCESS_KEY = 'oEW7yVNiL-LkNljKTLDG2-ssLCvlBPlLBTGwBpLyu9A';
const UNSPLASH_SECRET_KEY = 'EVGvBYLf8jolj5ga1XD0QkDW0JDwHJGlcUNoLNzHScg';
const UNSPLASH_APP_ID = '817126';

export interface UnsplashPhoto {
  id: string;
  width: number;
  height: number;
  color: string;
  description: string | null;
  alt_description: string | null;
  urls: {
    raw: string;
    full: string;
    regular: string;
    small: string;
    thumb: string;
  };
  user: {
    id: string;
    username: string;
    name: string;
    profile_image: {
      small: string;
      medium: string;
      large: string;
    };
  };
  links: {
    download: string;
    download_location: string;
  };
}

export interface UnsplashSearchResponse {
  total: number;
  total_pages: number;
  results: UnsplashPhoto[];
}

class UnsplashService {
  private baseUrl = 'https://api.unsplash.com';

  private async makeRequest<T>(endpoint: string, params: Record<string, string> = {}): Promise<T> {
    const url = new URL(`${this.baseUrl}${endpoint}`);
    
    // Add query parameters
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });

    const response = await fetch(url.toString(), {
      headers: {
        'Authorization': `Client-ID ${UNSPLASH_ACCESS_KEY}`,
        'Accept-Version': 'v1',
      },
    });

    if (!response.ok) {
      throw new Error(`Unsplash API error: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  async searchPhotos(query: string, page: number = 1, perPage: number = 20): Promise<UnsplashSearchResponse> {
    const params = {
      query,
      page: page.toString(),
      per_page: perPage.toString(),
      orientation: 'landscape', // Better for wallpapers
    };

    return this.makeRequest<UnsplashSearchResponse>('/search/photos', params);
  }

  async getPhoto(id: string): Promise<UnsplashPhoto> {
    return this.makeRequest<UnsplashPhoto>(`/photos/${id}`);
  }

  async downloadPhoto(photo: UnsplashPhoto): Promise<string> {
    // Trigger download tracking
    await fetch(photo.links.download_location, {
      headers: {
        'Authorization': `Client-ID ${UNSPLASH_ACCESS_KEY}`,
      },
    });

    // Return the full resolution URL
    return photo.urls.full;
  }

  // Get high-quality wallpaper URL
  getWallpaperUrl(photo: UnsplashPhoto, width: number = 1920, height: number = 1080): string {
    const { urls } = photo;
    
    // Use regular size for better performance, or full if we need higher quality
    if (width <= 1080 && height <= 1080) {
      return urls.regular;
    }
    
    return urls.full;
  }
}

export const unsplashService = new UnsplashService();
